import { Redo } from 'ui/icons';
import { testIds } from '../../../constants';
import { useSideBySideEditorContext } from '../../../contexts/SideBySideEditorContext';
import { useTranslations } from '../../../hooks/useTranslations';
import { BaseEditButton } from './BaseEditButton';

export const RedoButton = () => {
  const { redo } = useSideBySideEditorContext();
  const { t } = useTranslations();

  return (
    <BaseEditButton
      onClick={redo}
      testId={testIds.toolbarBtnRedo}
      tooltip={t('tooltip.buttonRedo')}
    >
      <Redo />
    </BaseEditButton>
  );
};
